// 组件对象，大写
import keywordOfModalTable from './keywordOfModalTable.vue'
export default keywordOfModalTable
